import * as React from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import type Company from 'modules/core/store/models/Company'

import FormatsSelector from 'modules/settings/components/FormatsSelector'
import LanguageSelector from 'modules/settings/components/LanguageSelector'
import CompanyGeneralForm from 'modules/settings/lib/forms/General'

interface Props {
  company: Company
}

const CompanyFormatsForm: React.FC<Props> = ({ company }) => {
  const [form] = React.useState(new CompanyGeneralForm(company.toJS()))

  const onSubmit = async () => {
    await asyncAction(() => company.save(form.data()))
    form.cleanAll()
  }

  return (
    <Section.Form
      illustration="chat-translate"
      title={i18n.t('settings.edit_company.formats_form.title')}
      description={i18n.t('settings.edit_company.formats_form.description')}
      onSubmit={onSubmit}
      isDirty={form.isDirty}
      submitLabel={i18n.t('common.submit')}
      paddingX="s0"
    >
      <LanguageSelector form={form} />
      <FormatsSelector form={form} />
    </Section.Form>
  )
}

export default observer(CompanyFormatsForm)
